(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["celebrity-blogs"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hzn-celeb-blogs').forEach(function (section) {
    var track = section.querySelector('[id^="hznCelebTrack-"]');
    if (!track) return;

    var dotsEl    = section.querySelector('[id^="hznCelebDots-"]');
    var prevBtn   = section.querySelector('.hzn-celeb-blogs__arrow--prev');
    var nextBtn   = section.querySelector('.hzn-celeb-blogs__arrow--next');
    var cards     = Array.from(track.children);
    var speed     = parseInt(section.dataset.autoSpeed) || 3500;
    var cols      = parseInt(getComputedStyle(section).getPropertyValue('--hzn-cb-columns')) || 3;
    var gap       = parseInt(getComputedStyle(section).getPropertyValue('--hzn-cb-gap')) || 24;
    var current   = 0;
var pageCount = cards.length;    var timer     = null;

    function getPageWidth() {
  if (!cards[0]) return 0;

  return cards[0].getBoundingClientRect().width + gap;
}

    function goTo(idx) {
      current = (idx + pageCount) % pageCount;
track.style.transform =
  'translateX(-' + (current * getPageWidth()) + 'px)';      updateDots();
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.hzn-cb-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function buildDots() {
      if (!dotsEl || pageCount <= 1) { if (dotsEl) dotsEl.style.display = 'none'; return; }
      dotsEl.innerHTML = '';
      for (var i = 0; i < pageCount; i++) {
        var btn = document.createElement('button');
        btn.className = 'hzn-cb-dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (idx) {
          btn.addEventListener('click', function () { goTo(idx); restartTimer(); });
        })(i);
        dotsEl.appendChild(btn);
      }
    }

    function startTimer() {
      timer = setInterval(function () { goTo(current + 1); }, speed);
    }
    function restartTimer() { clearInterval(timer); startTimer(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restartTimer(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restartTimer(); });

    // Touch swipe
    var tx = 0;
    track.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); restartTimer(); }
    }, { passive: true });

    // Pause on hover
    section.addEventListener('mouseenter', function () { clearInterval(timer); });
    section.addEventListener('mouseleave', startTimer);

    buildDots();
    startTimer();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-compact"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.hzn-testi2').forEach(function (el) {
    var reelEl  = el.querySelector('[id^="t2Reel-"]');
    if (!reelEl) return;
    var sid     = reelEl.id.replace('t2Reel-', '');
    var dotsEl  = document.getElementById('t2Dots-' + sid);
    var prevBtn = document.getElementById('t2Prev-' + sid);
    var nextBtn = document.getElementById('t2Next-' + sid);
    var speed   = parseInt(el.dataset.speed) || 4000;

    // Wrap all direct .t2-card children in an inner track div
    var cards = Array.from(reelEl.querySelectorAll('.t2-card'));
    var total = cards.length;
    if (total === 0) return;

    var inner = document.createElement('div');
    inner.className = 't2-reel-inner';
    cards.forEach(function (c) { inner.appendChild(c); });
    reelEl.appendChild(inner);

    var current = 0;
    var timer   = null;
    var cardW   = 0; // filled on first layout

    function getCardWidth() {
      return cards[0] ? cards[0].offsetWidth + (cards[0].offsetLeft > 0 ? 0 : 0) : 0;
    }

    function calcOffset(idx) {
      // Centre the active card inside the reel viewport
      var reelW = reelEl.offsetWidth;
      var cW    = cards[idx] ? cards[idx].offsetWidth : 0;
      var left  = 0;
      for (var i = 0; i < idx; i++) {
        left += cards[i].offsetWidth + (parseFloat(getComputedStyle(cards[i]).marginRight) || 0) * 2;
      }
      return left - (reelW / 2) + (cW / 2);
    }

    function goTo(idx, animate) {
      current = (idx + total) % total;

      cards.forEach(function (c, i) {
        c.classList.remove('is-active', 't2-animating');
      });

      var active = cards[current];
      active.classList.add('is-active');
      if (animate !== false) {
        void active.offsetWidth;
        active.classList.add('t2-animating');
        setTimeout(function () { active.classList.remove('t2-animating'); }, 450);
      }

      // Translate inner track so active card is centred
      requestAnimationFrame(function () {
        var offset = calcOffset(current);
        inner.style.transform = 'translateX(-' + Math.max(0, offset) + 'px)';
      });

      updateDots();
    }

    function updateDots() {
      if (!dotsEl) return;
      dotsEl.querySelectorAll('.t2-dot').forEach(function (d, i) {
        d.classList.toggle('is-active', i === current);
      });
    }

    function buildDots() {
      if (!dotsEl) return;
      if (total <= 1) { dotsEl.style.display = 'none'; return; }
      for (var i = 0; i < total; i++) {
        var btn = document.createElement('button');
        btn.className = 't2-dot' + (i === 0 ? ' is-active' : '');
        btn.setAttribute('aria-label', 'Go to ' + (i + 1));
        (function (n) { btn.addEventListener('click', function () { goTo(n); restart(); }); })(i);
        dotsEl.appendChild(btn);
      }
    }

    function start()   { if (speed > 0) timer = setInterval(function () { goTo(current + 1); }, speed); }
    function restart() { clearInterval(timer); start(); }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); restart(); });

    // Touch swipe
    var tx = 0;
    reelEl.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    reelEl.addEventListener('touchend',   function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) { goTo(current + (dx < 0 ? 1 : -1)); restart(); }
    }, { passive: true });

    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', start);

    // Window resize — recalculate position
    window.addEventListener('resize', function () { goTo(current, false); });

    buildDots();
    // Small delay so layout is painted and widths are available
    setTimeout(function () { goTo(0, false); start(); }, 80);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
